import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-view-report',
  templateUrl: './view-report.component.html',
  styleUrls: ['./view-report.component.scss'],
    encapsulation: ViewEncapsulation.ShadowDom
})
export class ViewReportComponent implements OnInit {
@Input() fileDetails:any;
  constructor(   private sanitizer: DomSanitizer,) { }

  ngOnInit(): void {
    //do nothing
  }

  transformYourHtml() {
    return this.sanitizer.bypassSecurityTrustHtml(this.fileDetails);
  }
}
